/**
 * Handle a request by doing nothing.
 * @returns {void} - Returns nothing to handle a request by doing nothing
 */
export default function doNothing() {}
